const MODULE = 'LAYOUT'
export const TOGGLE_NAVIGATION = `${MODULE}/TOGGLE_NAV`
